import { trackEvent } from 'utils';
import { CHECKOUT_LEGAL_SECTION_ID } from '../checkout/constants';
import type { CheckoutEditCard } from '../checkout/types';
import {
  CART_STEPS_CATEGORIES,
  CART_ACTIONS,
  CART_CHECKOUT_EDIT_LABEL,
  CART_TRACKING_LABEL
} from '../constants/analytics';

export function trackLegalDialogOpen(sectionId: string): void {
  const action = sectionId === CHECKOUT_LEGAL_SECTION_ID.TERMS ? CART_ACTIONS.AGB : CART_ACTIONS.PRIVACY;

  trackEvent(CART_STEPS_CATEGORIES.CHECKOUT, action, CART_TRACKING_LABEL.click);
}

export function trackCheckoutEditClick(card: CheckoutEditCard): void {
  trackEvent(CART_STEPS_CATEGORIES.CHECKOUT, CART_ACTIONS.EDIT, CART_CHECKOUT_EDIT_LABEL[card]);
}

export function trackOrderButtonClick(): void {
  trackEvent(CART_STEPS_CATEGORIES.CHECKOUT, CART_ACTIONS.BUY, CART_TRACKING_LABEL.click);
}

/** Gatsby event: the payment method (key of `currentPayment`) is the action, the order id the label. */
export function trackOrderSuccess(paymentMethod: string, orderId: number): void {
  trackEvent(CART_STEPS_CATEGORIES.CHECKOUT, paymentMethod, String(orderId));
}
